import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import TitledDropdown from "components/TitledDropdown";

import styles from "forms/forms.css";

const DropdownField = (props) => {
  const {
    dropdownComponent,
    field: { name, value },
    form: { errors, setFieldValue, submitCount },
    inputValueExtractor,
    isDisabled,
    isEdit,
    isInline,
    isUnselectable,
    label,
    linkingWord,
    onEdit,
    placeholder,
    unitSize,
    valueExtractor,
    values,
  } = props;

  return (
    <div
      className={cx(styles.field, {
        [styles.inline]: isInline,
        [styles.disabled]: isDisabled,
      })}
    >
      {linkingWord && <small>{linkingWord}</small>}
      <TitledDropdown
        component={dropdownComponent}
        inputValueExtractor={inputValueExtractor}
        isEdit={isEdit}
        isRequired={!!submitCount && errors[name]}
        isUnselectable={isUnselectable}
        placeholder={placeholder}
        onEdit={onEdit}
        onSelect={(v) => setFieldValue(name, v)}
        selectedValue={value}
        title={label}
        unitSize={unitSize}
        valueExtractor={valueExtractor}
        values={values}
      />
    </div>
  );
};

DropdownField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    errors: PropTypes.object,
    submitCount: PropTypes.number,
  }),
  isEdit: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInline: PropTypes.bool,
  isUnselectable: PropTypes.bool,
  label: PropTypes.string,
  linkingWord: PropTypes.string,
  onEdit: PropTypes.func,
  unitSize: PropTypes.number,
  values: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ).isRequired,
  valueExtractor: PropTypes.func,
  dropdownComponent: PropTypes.func,
  inputValueExtractor: PropTypes.func,
};

DropdownField.defaultProps = {
  isEdit: true,
  valueExtractor: (v) => v,
};

export default DropdownField;
